import React from 'react';
import { FileCheck2, CircleDashed } from 'lucide-react';
import { ValidationBadge } from './ValidationBadge';
import { EXPORT_DATE_LABEL } from '../../data/world/package';
import type { AuditFact } from '../../data/guide/sourceAudit';
type Props = {
  fact: AuditFact;
  title?: string;
  /** Título de la columna de lo que falta. */
  missingTitle?: string;
};

/**
 * Lo que documenta la configuración y lo que sigue faltando, con estados separados.
 * Nunca marca el bloque entero en verde: identificar un ítem no confirma la receta, el efecto ni la vigencia.
 */
export function ConfigAuditPanel({
  fact,
  title = 'Qué documenta la configuración',
  missingTitle = 'Falta por documentar'
}: Props) {
  return <div className="rounded-2xl border border-white/10 bg-[#0A1628] p-4 md:p-5" data-id="element-759" data-mp="wjvgkwy9zz1y">
      <p className="text-sm font-semibold text-white" data-id="element-760" data-mp="3v9vl49ojyte8">{title}</p>
      <div className="mt-3 grid gap-4 md:grid-cols-2" data-id="element-761" data-mp="3v7hvwhgk0bel">
        <div data-id="element-762" data-mp="429dk5ypq6s3">
          <ValidationBadge status="documentado" label={`Configuración del ${EXPORT_DATE_LABEL}`} data-id="element-763" data-mp="41zw56rqh7y0" />
          <ul className="mt-2 space-y-1.5 text-sm text-gray-300" data-id="element-764" data-mp="1uy3yl3v64jhu">
            {fact.known.map(k => <li key={k} className="flex gap-2" data-id="element-765" data-mp="1q0vprtvwtrt9">
                <FileCheck2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-300/80" aria-hidden="true" data-id="element-766" data-mp="1l9dp76xstt8t" />
                <span data-id="element-767" data-mp="1h8jzq94pk6dt">{k}</span>
              </li>)}
          </ul>
        </div>
        <div data-id="element-768" data-mp="1c8nvq9w0gey9">
          <ValidationBadge status="pendiente" label={missingTitle} data-id="element-769" data-mp="1c9gvgqwjy46w" />
          <ul className="mt-2 space-y-1.5 text-sm text-gray-300" data-id="element-770" data-mp="1c6kxx3om9hiz">
            {fact.missing.map(m => <li key={m} className="flex gap-2" data-id="element-771" data-mp="12ari9bflp7wz">
                <CircleDashed className="mt-0.5 h-4 w-4 shrink-0 text-amber-200/80" aria-hidden="true" data-id="element-772" data-mp="12b9ql6fjfcl9" />
                <span data-id="element-773" data-mp="yaqwf5q69ufw">{m}</span>
              </li>)}
          </ul>
        </div>
      </div>
      {fact.note && <p className="mt-3 border-t border-white/10 pt-3 text-xs text-gray-400" data-id="element-774" data-mp="2wmogbn8jtc10">{fact.note}</p>}
      <p className="mt-2 text-[11px] text-gray-500" data-id="element-775" data-mp="2snyy9hckf6b1">Fuente: {fact.sources.join(', ')} · no confirma la versión desplegada hoy · no comprobado en el juego</p>
    </div>;
}